import React, {useEffect, useRef} from 'react'
import SingleMessage from '../components/SingleMessage'
import ClientMessageOptionList from './ClientMessageOptionList';
import LoadingMessage from './LoadingMessage'


 
function MessageList(props) {
    const messagesEndRef = useRef(null);
    const scrollToBottom = () => {
        // console.log("scrollToBottom");
        messagesEndRef.current.scrollIntoView({/*behavior: "smooth"*/});
    }
    useEffect(scrollToBottom, [props.messages, props.optionList]);
    const messages = props.messages;
    const messageDoms = messages.map( x => <SingleMessage {...x} sendMessage={props.sendMessage} setImageUrl={props.setImageUrl}></SingleMessage> )
    return (
        <div className="message-list">
            {messageDoms}
            {props.isDisabled?<LoadingMessage></LoadingMessage>:null}
            {props.optionList.length!==0?<ClientMessageOptionList optionList={props.optionList} sendMessage={props.sendMessage}></ClientMessageOptionList>:null}
            <div ref={messagesEndRef}></div>
        </div>
    )
}



export default MessageList;